<template>
  <div
    class="company__logo"
    @mouseover="changeHoverIcon(true)"
    @mouseleave="changeHoverIcon(false)"
  >
    <div class="company__logo--left">
      <Picture
        class="logo"
        v-if="!isOpen && !hovered && logo"
        :url="logo.icon ? logo.icon : ''"
        alt="company_logo"
      />
      <Picture
        class="logo"
        v-else-if="isOpen && logo && logo.icon"
        :url="logo.icon ? logo.icon : ''"
        alt="company_logo"
      />
      <div
        v-else-if="!isOpen && hovered"
        class="logo"
        @click="changeOpen"
        :style="isOpen ? '' : 'cursor:pointer;'"
      >
        <Icon iconName="MenuRight" iconColor="#788694" />
      </div>

      <span v-if="logo && logo.lbl && logo.lbl.value.length">{{
        logo.lbl.value
      }}</span>
    </div>
  </div>
</template>
<script>
import Icon from 'Elements/Icon/Icon';
import Picture from 'Elements/Picture/Picture';

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    logo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      hovered: false
    };
  },
  methods: {
    changeHoverIcon(bool) {
      this.hovered = bool;
    },
    changeOpen() {
      this.$emit('change-open');
      this.hovered = false;
    }
  },
  computed: {},
  components: { Icon, Picture }
};
</script>

<style lang="scss" scoped>
.company__logo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
  padding-left: 24px;

  &--left {
    display: flex;

    .logo {
      width: 24px;
      height: 24px;
      margin-right: 24px;
    }
  }
}
</style>
